<template>
  <div v-loading="loading">
    <div class="fl p-r-10 bor-r-ccc" style="width:55%">
      <div class="fr m-b-10">
        <el-select v-model="type" placeholder="控件类型">
          <el-option v-for="option in inputTypes" :label="option.name" :value="option" v-if="!option.disabled">
          </el-option>
        </el-select>
        <el-button type="primary" @click="addInput">添加</el-button>
      </div>
      <div style="clear:both"></div>
      <div class="left-table">
        <el-table
          :data="data"
          :row-class-name="tableRowClassName"
          style="width: 100%">
          <el-table-column
            label="序号"
            width="70px">
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="名称">
            <template scope="scope">
              <span>{{ scope.row.default.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="类型">
              <template scope="scope">
                <span>{{ getTypeName(scope.row.default.type) }}</span>
              </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="300">
            <template scope="scope">
              <div>
                <el-button size="small" type="default" :disabled="scope.$index == 0" @click="sortUp(scope.$index)">上移</el-button>
                <el-button size="small" type="default" :disabled="scope.$index == data.length - 1" @click="sortDown(scope.$index)">下移</el-button>                
                <el-button size="small" type="default" @click="setCurInput(scope.row, scope.$index)">配置</el-button>
                <el-button size="small" type="default" @click="deleteInput(scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="m-t-10">
        <el-button type="primary" @click="post()" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </div>
    </div>
    <input-config class="m-l-10" :curInput="curInput" :inputList="data" width="42%" :showName="false"></input-config>
  </div>
</template>

<style scope>
  .left-table {
    max-height: 700px;
    overflow-y: auto;
  }
  .left-table .info-row {
    background: #c9e5f5;
  }
</style>

<script>
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  import inputConfig from './inputConfig'
  export default {
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        loading: false,
        isLoading: false,
        type: null, // 当前添加的控件类型
        allowType: [],  // 允许添加的控件类型
        data: [], // 控件数据
        curInput: {}, // 当前选中的控件
        curIndex: '', // 当前选中的控件索引
        inputTypes: [  // 可选控件类型
          { id: 10, name: '单行文本', field_name: 'input', disabled: false }
          // { id: 20, name: '密码', field_name: 'password', disabled: false },
          // { id: 30, name: '多行文本', field_name: 'textarea', disabled: false },
          // { id: 40, name: '单选框', field_name: 'radio', disabled: false },
          // { id: 50, name: '复选框', field_name: 'checkbox', disabled: false },
          // { id: 60, name: '下拉框', field_name: 'select', disabled: false },
          // { id: 70, name: '日期', field_name: 'date', disabled: false },
          // { id: 80, name: '日期时间', field_name: 'datetime', disabled: false },
          // { id: 90, name: '时间', field_name: 'time', disabled: false },
          // { id: 100, name: '富文本', field_name: 'editor', disabled: false },
          // { id: 110, name: '级联选择', field_name: 'link', disabled: false },
          // { id: 120, name: '外键选择', field_name: 'key', disabled: false },
          // { id: 130, name: '子表单', field_name: 'form', disabled: false },
          // { id: 140, name: '文件上传', field_name: 'file', disabled: false },
          // { id: 150, name: '人员选择', field_name: 'people', disabled: false },
          // { id: 160, name: '部门选择', field_name: 'struct', disabled: false },
          // { id: 170, name: '用户信息', field_name: 'userInfo', disabled: false },
          // { id: 180, name: '获取系统时间', field_name: 'dealtime', disabled: false }
        ],
        count: 0
      }
    },
    created() {
      this.loading = true
      this.getDetail()
    },
    methods: {
      tableRowClassName(row, index) {
        if (index === this.curIndex) {
          return 'info-row'
        }
        return ''
      },
      getTypeName(type) {
        let name = ''
        _(this.inputTypes).forEach((res) => {
          if (res.id == type) {
            name = res.name
            return false
          }
        })
        return name
      },
      getDetail() { // 获取配置详情
        this.apiGet(`form/controls/${this.dealId}`).then((res) => {
          if (res.code == 200) {
            this.allowType = res.data.allow_type.sort()
            this.data = res.data.data
            this.count = this.data.length
            let hasSetType = false
            _(this.inputTypes).forEach((item) => {  //  筛选可选用的控件类型
              if (_.indexOf(this.allowType, item.id) == -1) {
                item.disabled = true
              }
            })
          } else {
            _g.dealError(this, res)
          }
          this.loading = false
          this.$emit('setLoading', false)
        })
      },
      createInput(type) {
        let baseInput = require('../../Model/widgetAttr/index')
        let newInput = _.cloneDeep(baseInput)
        let attr = null
        switch (type) {
          case this.TYPE_INPUTTEXT:
            attr = require('../../Model/widgetAttr/text')
            break
          // case this.TYPE_PASSWORD: // 密码
          //   attr = require('../../Model/widgetAttr/password')
          //   break
          // case this.TYPE_TEXTAREA: // 多行文本
          //   attr = require('../../Model/widgetAttr/textarea')
          //   break
          // case this.TYPE_RADIO: // 单选框
          //   attr = require('../../Model/widgetAttr/radio')
          //   break
          // case this.TYPE_CHECKBOX: // 多选框
          //   attr = require('../../Model/widgetAttr/checkbox')
          //   break
          // case this.TYPE_SELECT: // 下拉框
          //   attr = require('../../Model/widgetAttr/select')
          //   break
          // case this.TYPE_DATE: // 日期
          //   attr = require('../../Model/widgetAttr/date')
          //   break
          // case this.TYPE_TIME: // 时间
          //   attr = require('../../Model/widgetAttr/time')
          //   break
          // case this.TYPE_BOTH_DATE_TIME: // 时间日期
          //   attr = require('../../Model/widgetAttr/datetime')
          //   break
          // case this.TYPE_FILE: // 文件
          //   attr = require('../../Model/widgetAttr/file')
          //   break
          // case this.TYPE_EDITOR: // 编辑器
          //   attr = require('../../Model/widgetAttr/editor')
          //   break
          // case this.TYPE_STRUCT: // 部门选择
          //   attr = require('../../Model/widgetAttr/struct')
          //   break
          // case this.TYPE_PERSON: // 人员选择
          //   attr = require('../../Model/widgetAttr/people')
          //   break
          // case this.TYPE_CASCADER: // 级联选择
          //   attr = require('../../Model/widgetAttr/cascader')
          //   break
          // case this.TYPE_FOREIGNKEY: // 外键
          //   attr = require('../../Model/widgetAttr/foreignKey')
          //   break
          // case this.TYPE_SUBFORM: // 子表单
          //   attr = require('../../Model/widgetAttr/subform')
          //   break
          // case this.TYPE_USER:
          //   attr = require('../../Model/widgetAttr/userInfo')
          //   break
          // case this.TYPE_DEALTIME:
          //   attr = require('../../Model/widgetAttr/dealtime')
          //   break
        }
        if (type == this.TYPE_FILE || type == this.TYPE_EDITOR) {
          // 文件或富文本编辑器，默认不显示和不筛选
          newInput.is_show = 0
          newInput.is_filter = 0
        }
        newInput = _.merge(newInput, _.cloneDeep(attr))
        return newInput
      },
      getUniqueName(sourceName) {
        return this.searchUniqueName(sourceName, [])
      },
      searchUniqueName(sourceName, array) {
        let ok = false
        this.count++
        if (!array.length) {
          _(this.data).forEach((res) => {
            if (res.default.name &&
              !res.default.is_deleted &&
              res.default.name[0] == sourceName[0] &&
              res.default.name.indexOf(sourceName + '_') > -1 &&
              (/_\d+$/g).test(res.default.name)) {
              // 对当前存在的字段名中有可能与当前添加字段名相等的进行筛选，条件如下：
              // 1、字段名存在
              // 2、没有被删除
              // 3、首字母相等
              // 4、包含当前添加字段名子串
              // 5、满足以"_数字"结尾
              array.push(res.default.name)
            }
          })
        }
        // console.log(JSON.stringify(array))
        ok = _.findIndex(array, (res) => {
          return res == sourceName + '_' + this.count
        }) == -1
        if (ok) {
          // 若不存在重复，则输出当前新字段名
          return sourceName + '_' + this.count
        } else {
          // 若存在重复，则count+1，以筛选出来的数组继续进行查重
          return this.searchUniqueName(sourceName, array)
        }
      },
      addInput() {
        if (!this.type) {
          _g.toastMsg(this, 'error', '请先选择添加的控件类型')
          return
        }
        let newInput = this.createInput(this.type.id)
        newInput.default.title = this.type.name
        newInput.default.name = this.getUniqueName(this.type.field_name)
        newInput.default.type = this.type.id
        this.data.push(newInput)
      },
      setCurInput(item, index) { // 设置当前配置的控件
        this.curInput = item
        this.curIndex = index
      },
      sortUp(index) { // 上移
        let temp = this.data[index]
        this.data.splice(index, 1)
        this.data.splice(index - 1, 0, temp)
        if (this.curIndex === index) {
          this.curIndex = index - 1
        } else if (this.curIndex === index - 1) {
          this.curIndex = index
        }
      },
      sortDown(index) { // 下移
        let temp = this.data[index]
        this.data.splice(index, 1)
        this.data.splice(index + 1, 0, temp)
        if (this.curIndex === index) {
          this.curIndex = index + 1
        } else if (this.curIndex === index + 1) {
          this.curIndex = index
        }
      },
      deleteInput(index) {  // 删除控件
        this.data.splice(index, 1)
        this.curInput = {}
        this.curIndex = ''
      },
      post() {
        this.isLoading = true
        let data = _.cloneDeep(this.data)
        _(data).forEach((res) => {
          delete res.selected
        })
        let postData = {
          data: data
        }
        this.apiPut(`form/controls/${this.dealId}`, '', postData).then((res) => {
          if (res.code == 200) {
            this.$emit('saveCallback', true)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      goback() {
        _g.goBack()
      }
    },
    watch: {
      '$route'(to, from) { // 监听路由改变
        this.loading = true
        this.$emit('setLoading', true)
        this.getListConfig()
      }
    },
    components: {
      inputConfig
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// paramsRender.vue?391b7c6a